import { apiFetch, apiPost, apiPut, apiDelete } from '@/lib/api-client';

export async function getTestimonials() {
  try {
    return await apiFetch<any[]>('/api/testimonials');
  } catch {
    return [];
  }
}

export async function getTestimonialById(id: string) {
  try {
    return await apiFetch<any>(`/api/testimonials/${id}`);
  } catch {
    return null;
  }
}

export async function createTestimonial(data: any) {
  return apiPost('/api/testimonials', data);
}

export async function updateTestimonial(id: string, data: any) {
  return apiPut(`/api/testimonials/${id}`, data);
}

export async function deleteTestimonial(id: string) {
  return apiDelete(`/api/testimonials/${id}`);
}
